import { Box } from '@chakra-ui/react';
import { FC } from 'react';

const MainBox: FC = ({ children }) => (
  <Box layerStyle="appWidth" m="0 auto">
    <Box layerStyle="mainBox">{children}</Box>
  </Box>
);

export default MainBox;
